export const cinemas = [
    {
        id: "C123456789",
        title: "Marvel",
        branches: [
            {
                id: "B123456789",
                state: "Lagos",
                branch: "Palms Mall Otta"
            },

            {
                id: "B123456689",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123456589",
                state: "Abuja",
                branch: "Jabi Lake Mall"
            }
        ],
        showTimes: ["09:00 AM", "11:30 PM", "02:30", "04:40 PM", "06:30 PM", "8:00 PM"]
    },

    {
        id: "C123456788",
        title: "Genesis",
        branches: [
            {
                id: "B123456799",
                state: "Lagos",
                branch: "Palms Mall Otta"
            },

            {
                id: "B123456798",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123456797",
                state: "Abuja",
                branch: "Jabi Lake Mall"
            },

            {
                id: "B123456796",
                state: "Port Harcourt",
                branch: "Sky Mall Amadi"
            }
        ],
        showTimes: ["10:00 AM", "1:30 PM", "03:30 PM", "05:40 PM", "07:30 PM", "9:20 PM"]
    },

    {
        id: "C123456787",
        title: "Leviticus",
        branches: [
            {
                state: "Ogun",
                branch: "Palms Mall Otta"
            },

            {
                state: "Jos",
                branch: "Power Mall Bassa"
            },

            {
                state: "Abuja",
                branch: "Sky Memorial Mall"
            }],
        showTimes: ["10:00 AM", "12:30 PM", "03:30 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

    {
        id: "C123456786",
        title: "Revelations",
        branches: [
            {
                id: "B013456789",
                state: "Lagos",
                branch: "Palms Mall"
            },

            {
                id: "B023456789",
                state: "Abuja",
                branch: "Nirvana Heights - Wuye"
            },

            {
                id: "B033456789",
                state: "Jos",
                branch: "Jabi Lake Kanke"
            }
        ],
        showTimes: ["09:00 AM", "12:45 PM", "02:20", "04:30 PM", "06:20 PM", "08:20 PM"]
    },

    {
        id: "C123456785",
        title: "Selemene",
        branches: [
            {
                id: "B123356789",
                state: "Lagos",
                branch: "Palms Mall Otta"
            },

            {
                id: "B123256789",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123156789",
                state: "Abuja",
                branch: "Jabi Lake Mall"
            }
        ],
        showTimes: ["10:00 AM", "12:30 PM", "03:30 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

    {
        id: "C123456784",
        title: "Invoker",
        branches: [
            {
                id: "B123446789",
                state: "Port Harcourt",
                branch: "Palms Mall Diobi"
            },

            {
                id: "B123436789",
                state: "Abuja",
                branch: "Avalanche Mall - Wuse 3"
            },

            {
                id: "B123426789",
                state: "Calabar",
                branch: "Edmilson Towers"
            },

            {
                id: "B123416789",
                state: "Jos",
                branch: "Kempimski Hotel"
            },

            {
                id: "B123406789",
                state: "Lagos",
                branch: "Transcorp Hotel"
            },
        ],
        showTimes: ["11:00 AM", "01:30 PM", "03:30 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

    {
        id: "C123456783",
        title: "Phantom",
        branches: [
            {
                id: "B123455789",
                state: "Lagos",
                branch: "Palms Mall"
            },

            {
                id: "B123454789",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123452789",
                state: "Abuja",
                branch: "Jabi Lake"
            },

            {
                id: "B123451789",
                state: "Calabar",
                branch: "Edmilson Towers"
            },

            {
                id: "B123450789",
                state: "Port Harcourt",
                branch: "Abaji Towers"
            }],
        showTimes: ["09:00 AM", "12:40 PM", "03:30 PM", "06:40 PM", "08:10 PM", "9:40 PM"]
    },

    {
        id: "C123456782",
        title: "Pangolin",
        branches: [
            {
                id: "B123456689",
                state: "Ogun State",
                branch: "Palms Mall"
            },

            {
                id: "B123456589",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123456489",
                state: "Abuja",
                branch: "Twin Towers"
            }],
        showTimes: ["11:00 AM", "02:30 PM", "03:40 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

    {
        id: "C123456781",
        title: "Sinestro",
        branches: [
            {
                id: "B123456799",
                state: "Lagos",
                branch: "Palms Mall - Lekki"
            },

            {
                id: "B123456779",
                state: "Illorin",
                branch: "Novare Mall"
            },

            {
                id: "B123456769",
                state: "Abuja",
                branch: "Jabi Lake Mall"
            }],
        showTimes: ["10:00 AM", "12:30 PM", "03:30 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

    {
        id: "C123456780",
        title: "Davion",
        branches: [
            {
                id: "B123456789",
                state: "Lagos",
                branch: "Palms Mall Otta"
            },

            {
                id: "B123456788",
                state: "Abuja",
                branch: "Novare Mall"
            },

            {
                id: "B123456787",
                state: "Abuja",
                branch: "Jabi Lake Mall"
            }],
        showTimes: ["10:00 AM", "12:30 PM", "03:30 PM", "05:40 PM", "07:20 PM", "9:00 PM"]
    },

]